export const NOTIFICATIONS_EVENTS = {
    MAIN: "Notifications - Latest 3 imported files"
}